<div class="header">
  <div class="header-precontent">
    <span>sito web in costruzione, resta connesso...</span>
  </div>
  <div class="header-content">
    <div class="mobile-menu" (click)="openOverlay()">
      <img src="/icons/menu.png" />
    </div>
    <a routerLink="/">
      <div class="header-logo">
        <img src="/images/logo.svg" />
      </div>
    </a>
    <div class="header-menu">
      <div class="header-menu-item" routerLink="/chi-siamo">
        <a routerLink="/chi-siamo" routerLinkActive="active">chi siamo</a>
      </div>
      <div class="header-menu-item" routerLink="/eventi">
        <a href="/eventi" routerLinkActive="active">eventi</a>
      </div>
      <!--
      <div class="header-menu-item" routerLink="/ohelcamp">
        <a href="/ohelcamp" class="ohel" routerLinkActive="active">ohel</a>
      </div>
      -->
      <div class="header-menu-item" routerLink="/dona">
        <a routerLink="/dona" routerLinkActive="active">dona</a>
      </div>
    </div>
    <div class="header-action">
      <a href="/mappa">vieni a trovarci</a>
    </div>
  </div>
</div>
<router-outlet></router-outlet>

@if (!router.url.includes("/mappa")) {
  <app-footer></app-footer>
}
<div
  class="header-overlay-background"
  (click)="closeOverlay()"
  [class.show]="showOverlay"
>
  <div class="header-overlay">
    <div class="header-overlay-content">
      <div class="header-overlay-menu">
        <br />
        <div class="header-menu-item" routerLink="/chi-siamo">
          <a routerLink="/chi-siamo" routerLinkActive="active">chi siamo</a>
        </div>
        <div class="header-menu-item" routerLink="/eventi">
          <a href="/eventi" routerLinkActive="active">eventi</a>
        </div>
        <div class="header-menu-item" routerLink="/mappa">
          <a routerLink="/mappa" routerLinkActive="active">vieni a trovarci</a>
        </div>
        <!--
        <div class="header-menu-item" routerLink="/ohelcamp">
          <a routerLink="/ohelcamp" routerLinkActive="active" class="ohel"
            >ohel camp</a
          >
        </div>
        -->
        <div class="header-menu-item" routerLink="/dona">
          <a routerLink="/dona" routerLinkActive="active">dona</a>
        </div>
      </div>
    </div>
  </div>
</div>
